import React, { useEffect, useRef } from 'react';
import { useField } from '@unform/core';
import PropTypes from 'prop-types';

import { Label } from './styles';

export default function Textarea({ name, label, children, ...rest }) {
  const inputRef = useRef(null);
  const { fieldName, defaultValue = '', registerField, error } = useField(name);

  useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef.current,
      path: 'value',
    });
  }, [fieldName, registerField]);

  const renderLabel = label || name;

  return (
    <Label htmlFor={fieldName}>
      {error && <span>{error}</span>}

      <textarea
        name={fieldName}
        ref={inputRef}
        id={fieldName}
        aria-label={fieldName}
        defaultValue={defaultValue}
        {...rest}
      />
      <span>{renderLabel}</span>
      {children}
    </Label>
  );
}

Textarea.propTypes = {
  label: PropTypes.string,
  name: PropTypes.string.isRequired,
  size: PropTypes.number,
  iconStyle: PropTypes.objectOf(PropTypes.any),
  children: PropTypes.element,
};

Textarea.defaultProps = () => ({
  label: '',
  size: null,
  iconStyle: null,
  children: null,
});
